<script>
    import Router from 'svelte-spa-router';
	import routes from './router';
    
    import Navigation from './components/organisms/Navigation/Navigation.svelte';
    import Splash from './components/organisms/Intro/Splash.svelte';
    import Login from './components/organisms/Intro/Login.svelte';
    import Instructions from './components/organisms/Intro/Instructions.svelte';
    import Sorry from './components/organisms/Intro/Sorry.svelte';
    
    import { db } from './firebase';
    import { user, checkPWA, ideas } from './store';
    import PWACheck from './helpers/pwacheck.svelte';
    import UserCheck from './helpers/usercheck.svelte';

    // listen to real time changes on all public ideas

    // This clearly needs refactoring. Doing it recursively or rethink the entire store data structire.
    // Also find a way read and update nested store-objects from a JS helper file.
    // But for now, this adds real time updates to all ideas shown in "Feed"

    let initialFetch = true;

    db.collection('ideas').where('isPublic', '==', true).where('isSecured', '==', true)
        .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach((change) => {
                if (change.type === "added") {
                    // console.log("New idea: ", change.doc.data());
                    // this check ensures, that the store is not messed up on mount / initially. only if new ideas appear afterwards
                    if(initialFetch) return;
                    if(change.doc.id in $ideas.newest.entries === false) {
                        // console.log("Added idea: ", change.doc.data());
                        // If there are already updates loaded, but the user has not yet clicked on "load latest", we need to append the newly created ideas to the updates store. 
                        // If we would append the new idea always with the given ones from the newest store, we would drop new ideas that already have been added to the updates store.
                        // So the user would only see one new idea on "load latest" instead if all new ones.
                        if(Object.keys($ideas.newest.updates).length) {
                            $ideas.newest.updates = Object.assign({[change.doc.id]: change.doc.data()}, $ideas.newest.updates);
                        } else {
                            $ideas.newest.updates = Object.assign({[change.doc.id]: change.doc.data()}, $ideas.newest.entries);
                        }
                    }
                }
                if (change.type === "modified") {
                    // console.log("Modified idea: ", change.doc.data());
                    if(change.doc.id in $ideas.newest.entries) $ideas.newest.entries[change.doc.id] = change.doc.data();
                    if(change.doc.id in $ideas.highlights.entries) $ideas.highlights.entries[change.doc.id] = change.doc.data();
                    if(change.doc.id in $ideas.popular.entries) $ideas.popular.entries[change.doc.id] = change.doc.data();
                }
                if (change.type === "removed") {
                    // console.log("Removed idea: ", change.doc.data());
                    // This assignment syntax is used to trigger a re-render
                    // https://github.com/sveltejs/svelte/issues/3211
                    if(change.doc.id in $ideas.newest.entries) $ideas.newest.entries = delete $ideas.newest.entries[change.doc.id] && $ideas.newest.entries;
                    if(change.doc.id in $ideas.highlights.entries) $ideas.highlights.entries = delete $ideas.highlights.entries[change.doc.id] && $ideas.highlights.entries;
                    if(change.doc.id in $ideas.popular.entries) $ideas.popular.entries = delete $ideas.popular.entries[change.doc.id] && $ideas.popular.entries;
                }
            });
            // set initialFetch to false after first batch has been loaded.
            initialFetch = false;
        });
</script>

<style lang="scss" global>
	@import "./styles/global.scss";
</style>

<!-- These two just check environment and -->
<PWACheck></PWACheck>
<UserCheck></UserCheck>

{#if $user === undefined}
    <!-- Show splash till authstate is available -->
    <Splash />
{:else}
    <!-- Check if touch/mobile devices -->
    {#if $checkPWA.isMobile}
        <!-- Check if NOT yet in PWA standalone mode -->
        {#if
            $checkPWA.instructionsToShow === 'installPrompt' || 
            $checkPWA.instructionsToShow === 'iOSBrowserTab' || 
            $checkPWA.instructionsToShow === 'iOSWebView' ||
            $checkPWA.instructionsToShow === 'AndroidBrowserTab' ||
            $checkPWA.instructionsToShow === 'AndroidWebView'
        }
            <!-- Show instructions how to install or add to homescreen the PWA -->
            <Instructions></Instructions>
        {:else}
            <!-- TODO: Allow anonymous, not logged in users to see an idea detail page by opening a deeplink -->
            {#if $user}
                <!-- Get started if already in PWA mode and logged in -->
                <main>
                    <section class="main__content">
                        <Router {routes} />
                    </section>
                    <Navigation />
                </main>
            {:else}
                <!-- Login / Register -->
                <Login />
            {/if}
        {/if}
    {:else}
        <!-- You shall not pass on Desktop -->
        <Sorry></Sorry>
    {/if}
{/if}